import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import useDataApi from '@eig-builder/core-utils/hooks/useDataApi'

import { getCrmApiOptions } from '../../../../helpers/fetch-options-helper'

const AccountDetailsContext = React.createContext({})

const AccountDetailsContextWrapper = ({ children }) => {
  const account = useSelector(state => state.crm.getAccountByIdResponse)
  const [faasStatusReq, getFaasStatus] = useDataApi(getCrmApiOptions(account, '/v1.0/fraud_prevention/faas_decision', 'text'))

  return (
    <AccountDetailsContext.Provider
      value={{
        faasStatus: faasStatusReq.data,
        getFaasStatus
      }}
      >
      {children}
    </AccountDetailsContext.Provider>
  )
}

AccountDetailsContextWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export { AccountDetailsContext }
export default AccountDetailsContextWrapper
